import { useState } from "react";

export const useNavigation = () => {
  const [activeId, setActiveId] = useState<string>("saved_templates");

  const navigationItems = ["saved_templates", "all", "circle_templates"];

  const onClickNavItem = (id: string) => {
    setActiveId(id);
  };

  return {
    activeId,
    navigationItems,
    onClickNavItem,
  };
};
